import React from 'react';
require(`../assets/${process.env.PAGE}/css/custom-alert-modal.css`);

function CustomAlertModal(props) {
    return (
        <div className="custom-alert-modal-backdrop">
            <div className="custom-alert-modal-containter">
                <div className="custom-alert-modal-content text-center">
                    {props.children}
                </div>
            </div>
        </div>
        );
};
export default CustomAlertModal;


/** WEBPACK FOOTER **
 ** ./src/components/CustomAlertModal.js
 **/